import configData from "./config.json";
import { resolveAppEnv } from "./resolveAppEnv.js";

const QURAN_PAGES_BASE_URL =
  "https://raw.githubusercontent.com/hafizmuhammadaslam10/rabbani-school-assets/v2/quran/";
const QUAIDA_PAGES_BASE_URL =
  "https://raw.githubusercontent.com/hafizmuhammadaslam10/rabbani-school-assets/v2/qauida/";

const modeKey = resolveAppEnv(import.meta.env.MODE);
const envConfig = configData[modeKey] || configData.local;

export const baseUrl = envConfig.API_BASE_URL;
export const s3baseUrl = envConfig.S3_BASE_URL;
export const associateBaseUrl = envConfig.ASSOCIATE_BASE_URL;
export const quranPagesBaseUrl = QURAN_PAGES_BASE_URL;
export const quaidaPagesBaseUrl = QUAIDA_PAGES_BASE_URL;
export const projectMode = envConfig.PROJECT_MODE;

export const xsAuthClientId = envConfig.XS_AUTH_CLIENT_ID;
export const xsAuthUrl = envConfig.XS_AUTH_URL;
export const xsAuthBootstrapUrl = envConfig.XS_AUTH_BOOTSTRAP_URL;
export const xsAccountUrl = envConfig.XS_ACCOUNT_URL;

export const peerHost = envConfig.PEER_HOST;
export const peerPort = envConfig.PEER_PORT;
export const peerPath = envConfig.PEER_PATH;
export const peerSecure = envConfig.PEER_SECURE;
export const turnIceUrls = envConfig.TURN_ICE_URLS;
